let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dn37Z")).then(() => parcelRequire('5EDpZ'));